// extracted by mini-css-extract-plugin
export default {"container":"register_container__WkJ21","wrapper":"register_wrapper__6rfR+"};